import { Directive, ElementRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from '../../auth/auth.service';

@Directive({
  selector: '[appHasRole]'
})
export class HasRoleDirective {
  private roles = [];

  constructor(
    private readonly element: ElementRef,
    private readonly templateRef: TemplateRef<void>,
    private readonly viewContainer: ViewContainerRef,
    private readonly authenticationService: AuthenticationService
  ) {}

  @Input()
  set appHasRole(roles: string[]) {
    this.roles = roles;
    this.updateView();
  }

  private updateView(): void {
    if (this.authenticationService.checkRoles(this.roles)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
